import { render, staticRenderFns } from "./UpdateEntity.vue?vue&type=template&id=5ba90d82&"
import script from "./UpdateEntity.vue?vue&type=script&lang=js&"
export * from "./UpdateEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UpdateEntity.vue"
export default component.exports